import { NumberSchema } from ".."

export const number = () => new NumberSchema()
